import React from 'react';
import { HelpIcon } from 'components/atoms/HelpIcon';
import { OverlayTrigger } from 'react-bootstrap';
import PaddedLabel from 'components/molecules/PaddedLabel';

class LabelWithHelpOverlay extends React.Component {
    render() {
        return <PaddedLabel>
            {this.props.children}
            <OverlayTrigger trigger="click" placement={this.props.placement || 'right'} overlay={this.props.overlay}>
                <HelpIcon />
            </OverlayTrigger>
        </PaddedLabel>;
    }
}

export default LabelWithHelpOverlay;



// WEBPACK FOOTER //
// ./src/components/molecules/LabelWithHelpOverlay.js